import React from "react";
import { makeStyles, TextField, MenuItem, Menu } from "@material-ui/core";
import { Button, IconButton } from "@material-ui/core";
import AddWidgetPopUp from "./AddWidgetPopUp";
import { useDispatch, useSelector } from "react-redux";
import LayoutButtonGroup from "./LayoutButtonGroup";
import IntlMessages from "util/IntlMessages";
import SelectLobbyPreset from "./LobbyPreset";
import { injectIntl } from "react-intl";
import { isUndefined, isNull } from "lodash";
import WbTwilightIcon from "@mui/icons-material/WbTwilight";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import NightsStayIcon from "@mui/icons-material/NightsStay";

const useStyles = makeStyles({
	header: {
		position: "relative",
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
		alignItems: " center",
		padding: "0px 15px",
		paddingTop: "10px"
	},
	TextFieldRoot: {
		color: "#fff",
		fontWeight: "bold",
		fontSize: "1.25rem"
	},
	paddingNone: {
		paddingTop: 0
	}
});

function Header(props) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const authUser = useSelector(state => state.auth.authUser);
	const Flags = useSelector(state => state.accountsData.Flags);
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleCloseMenu = ()=>{
		setAnchorEl(null)
	}

	const returnWelcomeMessage = () => {
		var now = new Date().getHours();
		if (5 <= now && now <= 9)
			return (
				<span style={{ display: "flex", alignItems: "center", gap: 8}}>
					<WbTwilightIcon style={{color: 'rgb(234, 228, 69)', boxShadow: '2px 4px 37px 25px white', backgroundColor: 'white', fontSize: 28, borderRadius: '8px'}}/>
					{`${props.intl.formatMessage({ id: "Massage.Good.Morning" })} ${authUser.user_fnamn
						}!`}
				</span>
			);
		if (10 <= now && now <= 11)
			return (
				<span style={{ display: "flex", alignItems: "center", gap: 8}}>
					<WbTwilightIcon style={{color: 'rgb(234, 228, 69)', boxShadow: '2px 4px 37px 25px white', backgroundColor: 'white', fontSize: 28, borderRadius: '8px'}}/>
					{`${props.intl.formatMessage({ id: "Massage.Good.Morning1" })} ${authUser.user_fnamn
						}!`}
				</span>
			);
		if (12 <= now && now <= 15)
			return (
				<span style={{ display: "flex", alignItems: "center", gap: 8}}>
					<WbSunnyIcon style={{color: 'rgb(234, 228, 69)', boxShadow: '2px 4px 37px 25px white', backgroundColor: 'white', fontSize: 28, borderRadius: '8px'}}/>
					{`${props.intl.formatMessage({ id: "Massage.Good.day" })} ${authUser.user_fnamn
						}!`}
				</span>
			);
		if (16 <= now && now <= 18)
			return (
				<span style={{ display: "flex", alignItems: "center", gap: 8}}>
					<WbTwilightIcon style={{color: 'rgb(234, 228, 69)', boxShadow: '2px 4px 37px 25px white', backgroundColor: 'white', fontSize: 28, borderRadius: '8px'}}/>
					{`${props.intl.formatMessage({ id: "Massage.Good.afternoon" })} ${authUser.user_fnamn
						}!`}
				</span>
			);
		if ((19 <= now && now <= 23) || (0 <= now && now <= 4))
			return (
				<span style={{ display: "flex", alignItems: "center", gap: 8}}>
					<NightsStayIcon style={{color: 'rgb(69, 172, 234)', fontSize: 28, borderRadius: '8px'}}/>
					{`${props.intl.formatMessage({ id: "Massage.Good.night" })} ${authUser.user_fnamn
						}!`}
				</span>
			);
		else return "";
	};

	return (
		<div className={classes.header}>
			<div className="align-items-center d-none d-md-flex" style={{ gap: 10 }}>
				{isNull(Flags.KontoLogo) ? (
					""
				) : (
					<img
						src={Flags.KontoLogo}
						alt=""
						style={{
							objectFit: "contain",
							maxHeight: isUndefined(props.ImageHeight)
								? 40
								: props.ImageHeight,
							height: "100%"
						}}
					/>
				)}
			</div>
			<p
				className="d-md-none"
				style={{
					color: "rgb(106, 106, 106)",
					fontWeight: 500,
					fontSize: "20px"
				}}
			>
				{returnWelcomeMessage()}
			</p>
			<p
				className="d-none d-md-block"
				style={{
					color: "rgb(106, 106, 106)",
					fontWeight: 500,
					fontSize: "20px",
					left: "50%",
					transform: "translateX(-50%)",
					position: "absolute"
				}}
			>
				{returnWelcomeMessage()}
			</p>
			<div className="d-flex align-items-center">
				{props.editing && (
					<LayoutButtonGroup
						layout={props.Breakpoint}
						onHandleChange={props.onHandleChange}
					/>
				)}
				{props.editing && <AddWidgetPopUp addBlocks={props.addBlocks} />}
				{props.editing && props.LobbyPreset === "custom" && (
					<Button
						variant="outlined"
						color="primary"
						size="small"
						onClick={() => props.onSetEditing()}
					>
						<IntlMessages id="Save" />
					</Button>
				)}
				<IconButton color="primary" size="small" onClick={(event)=>setAnchorEl(event.currentTarget)}>
					<MoreVertIcon/>
				</IconButton>	
				<Menu
					id="simple-menu"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleCloseMenu}
				>
					{props.LobbyPreset === "custom" && <MenuItem onClick={() => {
						setAnchorEl(null);
						props.onSetEditing()
					}}>
						<IntlMessages id="Edit" />					
					</MenuItem>
					}
					<SelectLobbyPreset
						value={props.LobbyPreset}
						onMenuClick={handleCloseMenu}
						onChange={props.onHandleChangeLobbyPreset}
					/>
				</Menu>
			</div>
		</div>
	);
}

export default injectIntl(Header);
